/**
 * Where to send someone once they have signed in.
 *
 * The guard stashes the path it turned them away from in router state, so a
 * deep link into the dashboard survives the round trip through the login form.
 *
 * Same-site paths only. A `from` that arrived from anywhere but our own guard —
 * a crafted link, a stale history entry — would otherwise make the sign-in
 * screen an open redirect wearing the university's domain, which is exactly the
 * shape of a credible phishing hop.
 */
export function redirectTarget(location: { state: unknown }): string {
  const state = location.state;

  if (typeof state === 'object' && state !== null && 'from' in state) {
    const from = (state as { from: unknown }).from;

    // `//evil.example` is a protocol-relative URL, not a path.
    if (typeof from === 'string' && from.startsWith('/') && !from.startsWith('//')) {
      return from;
    }
  }

  return '/';
}
